define.alias("shared/components/shared/post/secondary/caption-writer/loader", "media/components/shared/post/secondary/caption-writer/loader");